import { useEffect, useRef, useState } from 'react';

const HOLD_DELAY = 550;
const DISPLAY_TIME = 1800;

const useLongPressTooltip = (onActivate) => {
  const [isVisible, setIsVisible] = useState(false);
  const holdTimer = useRef(null);
  const hideTimer = useRef(null);
  const didLongPress = useRef(false);
  const touchStart = useRef(null);

  const clearHoldTimer = () => {
    window.clearTimeout(holdTimer.current);
    holdTimer.current = null;
  };

  useEffect(() => () => {
    window.clearTimeout(holdTimer.current);
    window.clearTimeout(hideTimer.current);
  }, []);

  const onPointerDown = (event) => {
    if (event.pointerType !== 'touch') return;

    clearHoldTimer();
    window.clearTimeout(hideTimer.current);
    didLongPress.current = false;
    touchStart.current = { x: event.clientX, y: event.clientY };

    holdTimer.current = window.setTimeout(() => {
      didLongPress.current = true;
      setIsVisible(true);
      hideTimer.current = window.setTimeout(() => setIsVisible(false), DISPLAY_TIME);
    }, HOLD_DELAY);
  };

  const onPointerMove = (event) => {
    if (event.pointerType !== 'touch' || !touchStart.current) return;
    const distanceX = Math.abs(event.clientX - touchStart.current.x);
    const distanceY = Math.abs(event.clientY - touchStart.current.y);
    if (distanceX > 10 || distanceY > 10) clearHoldTimer();
  };

  const finishPress = () => {
    clearHoldTimer();
    touchStart.current = null;
  };

  const onClick = (event) => {
    if (didLongPress.current) {
      event.preventDefault();
      didLongPress.current = false;
      return;
    }
    setIsVisible(false);
    onActivate();
  };

  return {
    isVisible,
    buttonProps: {
      onClick,
      onPointerDown,
      onPointerMove,
      onPointerUp: finishPress,
      onPointerCancel: finishPress,
      onPointerLeave: finishPress,
    },
  };
};

export default useLongPressTooltip;
